<template>
<div class="chapter">
<div class="inner_page">
<p class="frontflap"><a id="ch00_fm01"></a><a id="page_ii"></a><strong>GARBAGE PAIL KIDS</strong>—a series of collectible stickers produced by Topps in the 1980s—combined spectacular artwork and over-the-top satire. The result was an inspired collaboration between avant-garde cartoonists and humorists including Art Spiegelman, Mark Newgarden, John Pound, Tom Bunk, and Jay Lynch. This first-ever compilation of Series 1 through Series 5 from 1985 and 1986 celebrates this pop culture phenomenon, and includes images of all 206 rare and hard-to-find stickers.<br/><br/></p>
<p class="frontflap">Copyright © 2012 The Topps Company, Inc. All rights reserved.</p>
<p class="image"><a id="page_iii"></a><img alt="Image" src="images/frondcase.jpg"/></p>
<p class="image"><a id="page_iv"></a><img alt="Image" src="images/endpaper1.jpg"/></p>
<p class="image"><a id="page_v"></a><img alt="Image" src="images/endpaper2.jpg"/></p>
<p class="image"><a id="page_vi"></a><img alt="Image" src="images/endpaper3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01.vue?68f3b622